import type { BossDrawEvent } from './open-world-boss-art';
import type { BossStrikeDraw } from './open-world-boss-strike-fx';

/**
 * **Os acontecimentos dos bosses, prontos para a arte deles** (gates V28I.Z.1 e
 * V28I.CF.1A).
 *
 * Duas traduções, e nenhuma decisão:
 * - o raio autoritativo passa de milli-unidades a unidades de desenho;
 * - uma etapa (`strike`) de um boss que está a correr o Bombardeio de
 *   Profundidade vai SEM o anel genérico. Os quatro círculos já dizem onde está
 *   o perigo, e um anel a abrir até ao raio passava por cima do casco e parecia
 *   uma quinta área. Os estilhaços ficam, e todas as outras habilidades
 *   continuam com o anel.
 *
 * A habilidade não viaja no acontecimento: sai do golpe em curso desse boss, que
 * a mesma trama publica.
 */
export function openWorldBossEventsForArt(
  events: readonly (BossDrawEvent & { readonly radiusMu?: number })[],
  strikes: readonly {
    readonly id: string;
    readonly strike: Pick<BossStrikeDraw, 'ability'> | null;
  }[],
  worldUnits: (mu: number) => number,
): readonly BossDrawEvent[] {
  return events.map((event) => {
    const ringless =
      event.kind === 'strike' &&
      strikes.some(
        (entry) => entry.id === event.id && entry.strike?.ability === 'depth_bombardment',
      );
    if (event.radiusMu === undefined && !ringless) {
      return event;
    }
    return {
      ...event,
      ...(event.radiusMu === undefined ? {} : { radius: worldUnits(event.radiusMu) }),
      ...(ringless ? { ring: false } : {}),
    };
  });
}
